import React, { useState } from 'react'
import { QueryBuilderMaterial } from '@react-querybuilder/material';
import { Field, RuleGroupType } from 'react-querybuilder';
import { formatQuery, QueryBuilder } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.scss';

const fields = [
    { name: 'firstName', label: 'First Name' },
    { name: 'lastName', label: 'Last Name' },
];

const initialQuery = {
    combinator: 'and',
    rules: [
        { field: 'firstName', operator: 'beginsWith', value: 'Stev' },
        { field: 'lastName', operator: 'in', value: 'Vai,Vaughan' },
    ],
};


export default function UiRuleBuilder(props) {

    const [query, setQuery] = useState(initialQuery);

    return (
        <>
            <QueryBuilderMaterial>
                <QueryBuilder
                    fields={fields}
                    query={query}
                    onQueryChange={setQuery}
                />
            </QueryBuilderMaterial>

            {/* <pre>
                <code>{formatQuery(query, 'json')}</code>
            </pre> */}

        </>
    )
}
